<template>
    <v-toolbar
        text
        elevation="0"
        class="pl-10"
        height="30"
    >
        <HomeNavigation class="ml-1 mt-2" />
        <BookingNavigation class="ml-1 mt-2" />
        <DriverNavigation class="ml-1 mt-2" />
        <MessagingMenu class="ml-1 mt-2" />
        <PendingDriverApplicationCount class="mr-10 mt-2" />
        <OnlineChannelsMenu class="ml-1 mt-2"/>

    </v-toolbar>
</template>

<script>
import BookingNavigation from './BookingNavigation'
import MessagingMenu from '../messaging/MessagingMenu'
import HomeNavigation from './HomeNavigation'
import OnlineChannelsMenu from '../messaging/OnlineChannelsMenu'
import DriverNavigation from './DriverNavigation'
import PendingDriverApplicationCount from './PendingDriverApplicationCount'

export default {
    name: "ToolBar",
    components: {DriverNavigation, OnlineChannelsMenu, HomeNavigation, MessagingMenu, BookingNavigation, PendingDriverApplicationCount},
    data() {
        return {
            appTitle: 'Awesome App',
            sidebar: false,
            menuItems: [
                
                {title: 'New Booking', path: '/signin', icon: 'face'},
            ]
        }
    }
}
</script>

<style scoped>

</style>